import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { FaPlay } from "react-icons/fa";

import blogArray from "../../DataJS/blogNews.js";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    setBlogs(blogArray);
  }, []);

  return (
    <>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>

        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">News & Events</h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>News & Events</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="rs-postbox-area section-space"
        style={{ paddingTop: "50px" }}
      >
        <div className="container">
          <span
            className="rs-section-subtitle has-theme-orange justify-content-center text-capitalize"
            style={{ marginBottom: "40px" }}
          >
            <FaPlay color="#EA5501" size={12} />
            Our Latest Media News & Events
          </span>
          <div className="rs-postbox-wrapper">
            <div className="row g-5">
              {blogs.map((blog) => (
                <div key={blog.id} className="col-lg-4 col-md-6">
                  <article className="rs-postbox-item">
                    <div className="rs-postbox-thumb">
                      <Link to={`/news/news-details/${blog.id}`}>
                        <img src={blog.img} alt={blog.title} />
                      </Link>

                      {/* <div className="rs-postbox-tag">
                        <Link to="/news-media-details">{blog.tag}</Link>
                      </div> */}
                    </div>

                    <div className="rs-postbox-content">
                      <div className="rs-postbox-meta-list">
                        {/* <span>
                          By <Link to="/news-media-details">{blog.author}</Link>
                        </span> */}

                        <span>
                          <Link to={`/news/news-details/${blog.id}`}>
                            {blog.date}
                          </Link>
                        </span>
                      </div>

                      <h3 className="fs-2">
                        <Link to={`/news/news-details/${blog.id}`}>
                          {blog.title}
                        </Link>
                      </h3>

                      <p>{blog.description.slice(0, 50)}...</p>
                    </div>

                    <div className="rs-postbox-btn">
                      <Link
                        className="rs-btn has-theme-orange has-icon has-bg"
                        to={`/news/news-details/${blog.id}`}
                      >
                        Continue Reading
                        <span className="icon-box">
                          <FiArrowRight />
                        </span>
                      </Link>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          </div>

          {/* pagination */}
          <div className="row">
            <div className="col-xl-6">
              <div className="pagination-wrapper mt-40">
                <div className="common-pagination text-start">
                  <nav>
                    <ul>
                      <li>
                        <Link className="current">1</Link>
                      </li>
                      <li>
                        <Link to="#">2</Link>
                      </li>
                      <li>
                        <Link to="#">3</Link>
                      </li>
                      <li>
                        <Link to="#">→</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
